// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { satisfies } from 'semver';
import Vue from 'vue';
import Vuex from 'vuex';
import VueToast from 'vue-toast-notification';
import Vuelidate from 'vuelidate';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import App from './App';
import router from './router';

Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(VueToast, {
  position: "bottom-left"
});

Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    totalPricing: 0,
    maxPackageLimit: 5000,
    selectedPackage: null,
    selectedPackageInfo: {},
    packages: {
      images: {
        commission: 0.25,
        basic: {
          base: 499,
          hosted_48_hours: 999,
          sub_domains: 999,
          additional_images: 175,
          valid_days: 21,
          additional_min_images: 0,
          additional_max_images: 25,
        },
        standard: {
          base: 999,
          hosted_48_hours: 999,
          sub_domains: 999,
          valid_days: 14,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 22,
        },
        premium: {
          base: 1599,
          hosted_48_hours: 999,
          sub_domains: 999,
          valid_days: 7,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 19,
        }
      },
      video: {
        commission: 0.25,
        basic: {
          base: 599,
          hosted_48_hours: 999,
          sub_domains: 999,
          valid_days: 21,
          additional_videos: 399,
          additional_min_videos: 0,
          additional_max_videos: 11,
        },
        standard: {
          base: 1299,
          hosted_48_hours: 999,
          sub_domains: 999,
          valid_days: 14,
          additional_videos: 399,
          additional_min_videos: 0,
          additional_max_videos: 9,
        },
        premium: {
          base: 2699,
          hosted_48_hours: 999,
          sub_domains: 999,
          valid_days: 7,
          additional_videos: 399,
          additional_min_videos: 0,
          additional_max_videos: 5,
        }
      }
    }
  },
  mutations: {
    selectedPackage (state, payload) {
      state.selectedPackageInfo = payload;
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store,
});



// WEBPACK FOOTER //
// ./src/main.js